import { createSlice } from "@reduxjs/toolkit";
import { getquestionThunk } from "../thunk/RootThunk";
/**
 * --------------------------------------------------
 * Question Slice
 * --------------------------------------------------
 * This slice manages the state for fetching questions
 * from the server.
 *
 * Data flow:
 * UI → dispatch(getquestionThunk)
 * → pending / fulfilled / rejected handled here
 *
 * Only async state is handled in this slice,
 * so no normal reducers are required.
 */

/**
 * Question slice state structure
 */
export interface QuestionState {
  question: object;
  loading: boolean;
  error: any;
  tokenExpiredError: boolean;
}
/**
 * Initial state of question slice
 */
const initialState: QuestionState = {
  question: [],
  loading: false,
  error: null,
  tokenExpiredError: false
};
/**
 * Alias export for getquestionThunk
 * Used for cleaner imports in components
 */
export const getquestion: any = getquestionThunk;

/**
 * Question Slice Definition
 */
const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /**
       * Triggered when getquestionThunk API call starts
       * Used to show loader in UI
       */
      .addCase(getquestion.pending, (state: any, action) => {
        state.loading = true;
      })
      /**
       * Triggered when API call is successful
       * Stores fetched question data in state
       */
      .addCase(getquestion.fulfilled, (state: any, action) => {
        state.loading = false;
        state.question = [action.payload];
        if (action.payload.data.ok === false && action.payload.data.http$.status === 401) {
          state.tokenExpiredError = true;
        }
      })
      /**
       * Triggered when API call fails
       * Stores error and stops loader
       */
      .addCase(getquestion.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default questionSlice.reducer;
